<script>
  export let idUnico = 'h2';
  export let content;
  import { onMount } from 'svelte';
  import { location } from 'svelte-spa-router';

  let spaceIndex;
  let apresentacao = false;

  if ($location === '/' || Number($location.split('/')[1]) === 1) {
    apresentacao = true;
  }

  onMount(() => {
    content = content.trim();
    spaceIndex = content.indexOf(' ');
  });
</script>

<div class="container {apresentacao ? '' : 'titulo'}" id={idUnico}>
  <h2 class={apresentacao ? 'apresentacao' : ''}>
    <span>{content.substring(0, spaceIndex)}</span>
    {@html content.substring(spaceIndex + 1)}
  </h2>
</div>

<style>
  h2 span {
    color: var(--VERDE_CLARO);
  }
  .container.titulo {
    margin: 3rem auto -0.5rem auto;
  }
  h2.apresentacao {
    margin: 3rem 0 -1rem 0;
  }
  @media (max-width: 800px) {
  }
</style>
